import {gql} from "@apollo/client";

export const GET_SCHEDULES = gql`
	query GetSchedules ($filter: ScheduleFilterInput) {
		schedules(where: $filter) {
			nodes {
				id
				description
				cron
				cronFrom
				enabled
				job {
					description
				}
			}
		}
	}
`;
